import { Alert, Backdrop, Box, Button, CircularProgress, CssBaseline, FormControl, FormHelperText, Grid, Paper, Snackbar, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Toolbar, styled } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../header/Header";
import SideDrawer from "../header/SideDrawer";
import AddIcon from "@mui/icons-material/Add"
import Modal from "../modal/Modal";
import { axiosClient } from "../AxiosClient";

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const ButtonAdd = styled(Button)({
    flexGrow: 0,
    borderRadius: '20px',
    gap: '10px',
    backgroundColor: '#161e55',
    color: '#ffff',
    margin: '0px 1rem',
    '&:hover': {
        backgroundColor: '#A8C8AF',
    },
});

const TextMessage = styled(FormHelperText)({
    color: 'red'
})

export default function Sucursales() {
    const {nameCommerce, uuidCommerce} = useParams();
    const [branchOffices, setBranchOffices] = useState();
    const titleColumns = ['Encargado', 'Contacto', 'Dirección', 'Ciudad', 'Departamento'];
    const [isModal, setIsModal] = useState(false);
    const [address, setAddress] = useState("");
    const [city, setCity] = useState("");
    const [department, setDeparment] = useState("");
    const [cellphone, setCellphone] = useState("");
    const [phone, setPhone] = useState("");
    const [name, setName] = useState("");
    const [personInCharge, setPersonInCharge] = useState("");
    const [errorCellphone, setErrorCellphone] = useState("");
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const [severity, setSeverity] = useState("");
    const [message, setMessage] = useState("");
    
    const [newBranchOffice, setNewBranchOffice] = useState("");
    const handleAddBranchOffices = () => {
        setIsModal(!isModal)
    }

    const handleClosedModal = () => {
        setIsModal(false)
        setAddress("")
        setCity("")
        setDeparment("")
        setCellphone("")
        setPhone("")
        setName("")
        setPersonInCharge("")
        setErrorCellphone(false)
    }

    const handleChangeAddress = (event) => {
        setAddress(event.target.value)
    }

    const handleChangeCity = (event) => {
        setCity(event.target.value)
    }

    const handleChangeDeparment = (event) => {
        setDeparment(event.target.value)
    }

    const handleChangeCellphone = (event) => {
        setCellphone(event.target.value)
    }

    const handleChangePhone = (event) => {
        setPhone(event.target.value)
    }

    const handleChangeName = (event) => {
        setName(event.target.value)
    }

    const handleChangePersonInCharge = (event) => {
        setPersonInCharge(event.target.value)
    }

    const handleSubmit = (event) => {
        const lengtNumberCellphone = 10
        event.preventDefault();
        if(cellphone != "" && cellphone.length!=lengtNumberCellphone) {
            setErrorCellphone(true)
        } else {
            setErrorCellphone(false)
            setOpenBackdrop(true)
            const body = {
                address: address,
                city: city,
                department: department,
                cellphone: cellphone,
                phone: phone,
                name: name,
                personInCharge: personInCharge,
                commerceUuid: uuidCommerce
            }
            axiosClient.post("/v1/branch-offices/", body).then(response => {
                handleClosedModal()
                setOpenBackdrop(false)
                setOpenSnackbar(true)
                setMessage("Se creó exitosamente la sucursal")
                setTimeout(setSeverity("success"), 5000)
                setNewBranchOffice(response.data.uuid)
            }).catch(error => {
                setOpenBackdrop(false)
                setOpenSnackbar(true)
                setMessage(error.response
                    ? "Error en la creación de la sucursal"
                    : "Error en la creación del comercio")
                setSeverity("error")
                console.log('Error: ' + error)
            })
        }
        
    }

    const handleClosedSnanck = (event, reason) => {
        if(reason == 'clickaway'){
            return;
            
        }
        setOpenSnackbar(false) 
    }

    useEffect(() => {
        if(localStorage.getItem('userUuid') == null) {
            window.location = '/admin';
        }

        axiosClient.get("/v1/branch-offices/by-commerce/" + uuidCommerce).then(response => {
            setBranchOffices(response.data)
        }).catch(error => {
            if(error.response) {
                alert("Server connection error")
            }
            console.log("Badrequest: " + error.message)
        }) 
    }, [newBranchOffice])

    return (
        <React.Fragment>
            {/* <Box sx={{ display: 'flex'}}> */}
                {/* <CssBaseline /> */}
                {/* <Header position='fixed' /> */}
                {/* <SideDrawer></SideDrawer> */}
                <br></br>
                <Toolbar />
                <Box sx={{ width: '100%'}}>
                    <Stack spacing={2}>
                        <Item>.</Item>
                        <Item></Item>
                        <Grid container spacing={2} sx={{alignItems: "center"}}>
                            <Grid item xs={6}>
                                <h1>Sucursales de {nameCommerce}</h1>
                            </Grid>
                            <Grid item xs={6}>
                                <ButtonAdd onClick={handleAddBranchOffices}><AddIcon></AddIcon></ButtonAdd>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <TableContainer component={Paper}>
                                <Table sx={{ minWidth: 650}} aria-aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            {titleColumns.map(title => (
                                                <TableCell key={title} align="center">{title}</TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {branchOffices ? branchOffices?.sucursales?.map(sucursal => (
                                            <TableRow key={sucursal.uuid} sx={{ '&:last-child td, &:last-child th': { border: 0 }}}>
                                                <TableCell align="center">{sucursal.personInCharge}</TableCell>
                                                <TableCell align="center">{sucursal.cellphone} / {sucursal.phone}</TableCell>
                                                <TableCell align="center">{sucursal.address}</TableCell>
                                                <TableCell align="center">{sucursal.city}</TableCell>
                                                <TableCell align="center">{sucursal.department}</TableCell>
                                            </TableRow>
                                        )): <div>Cargando Contenido</div>}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Stack>
                </Box>
                <Toolbar />
            {/* </Box> */}
            {isModal && 
                <Modal activeModal={isModal} handleModal={handleClosedModal}>
                    <Box textAlign={'center'}>
                        <h2>Creación de sucursales</h2>
                    </Box>
                    <Box width={'80%'} margin={'1rem auto'}>
                        <form onSubmit={handleSubmit}>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <TextField id="address" label="Dirección" variant="outlined" value={address} onChange={handleChangeAddress} type="text"></TextField>
                                </FormControl>
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <TextField id="city" label="Ciudad" variant="outlined" value={city} onChange={handleChangeCity} type="text"></TextField>
                                </FormControl>
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <TextField id="department" label="Departamento" variant="outlined" value={department} onChange={handleChangeDeparment} type="text"></TextField>
                                </FormControl>
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <TextField id="cellphone" label="Celular" variant="outlined" value={cellphone} onChange={handleChangeCellphone} type="text"></TextField>
                                </FormControl>
                                {errorCellphone && <TextMessage>Formato incorrecto</TextMessage>}
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <TextField id="phone" label="Teléfono" variant="outlined" value={phone} onChange={handleChangePhone} type="text"></TextField>
                                </FormControl>
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <TextField id="name" label="Nombre" variant="outlined" value={name} onChange={handleChangeName} type="text"></TextField>
                                </FormControl>
                            </Box>
                            <Box mt={5}>
                                <FormControl fullWidth>
                                    <TextField id="personInCharge" label="Persona a cargo" variant="outlined" value={personInCharge} onChange={handleChangePersonInCharge} type="text"></TextField>
                                </FormControl>
                            </Box>
                            <Box mt={2} textAlign={'center'}>
                                    <ButtonAdd type="submit">Crear sucursal</ButtonAdd>
                            </Box>
                        </form>
                    </Box>
                </Modal>
                }
                <Backdrop sx={{background: 'rgba(255,255,255,0.1)', zIndex: '5', width: '50%', margin: 'auto auto auto 30vw'}} open={openBackdrop}>
                    <CircularProgress color="success"></CircularProgress>
                </Backdrop>
                <Snackbar open={openSnackbar} autoHideDuration={5000} onClose={handleClosedSnanck}>
                    <Alert onClose={handleClosedSnanck} severity={severity} sx={{width: '100%'}}>{message}</Alert>
                </Snackbar>
        </React.Fragment>
    )
}
